<!--
  Kommerzielle Landingpage „Weinautomat kaufen“. Muster wie die übrigen
  Cluster-Seiten. Spielerei: Weinglas, das sich füllt (reine CSS/SVG, clip-path).
-->
<section class="wma-hero">
  <div class="content content--wide wma-hero__grid">
    <div class="wma-hero__text reveal">
      <div class="wma-glass" aria-hidden="true">
        <svg viewBox="0 0 100 100" role="img">
          <defs>
            <clipPath id="wma-bowl-clip">
              <path d="M34,18 C34,42 42,53 50,53 C58,53 66,42 66,18 Z" />
            </clipPath>
          </defs>
          <rect class="wma-glass__wine" x="30" y="6" width="40" height="50" clip-path="url(#wma-bowl-clip)" />
          <g class="wma-glass__outline">
            <path d="M34,18 C34,42 42,53 50,53 C58,53 66,42 66,18 Z" />
            <line x1="50" y1="53" x2="50" y2="76" />
            <line x1="38" y1="78" x2="62" y2="78" />
          </g>
        </svg>
      </div>
      <span class="wma-eyebrow" i18n="@@wma.hero.eyebrow">Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@wma.hero.h1">Weinautomat kaufen</h1>
      <div class="line"></div>
      <p class="wma-lead" i18n="@@wma.hero.lead">
        Verkaufe Wein rund um die Uhr – direkt am Weingut, ohne Öffnungszeiten und Personal.
        Die <span class="tm">marktbox</span> ist dein Weinautomat für die Direktvermarktung:
        bargeldlos, app-gesteuert und mit Altersverifikation.
      </p>
      <div class="wma-cta">
        <a class="btn btn-primary wma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@wma.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="wma-cta__ghost" href="#preise" (click)="scrollTo($event, 'preise')" i18n="@@wma.hero.ctaGhost">Kaufen oder mieten? ↓</a>
      </div>
    </div>
    <figure class="wma-hero__media reveal">
      <img src="assets/headers/marktbox-02-1440.webp"
        alt="marktbox Weinautomat für die Direktvermarktung am Weingut" i18n-alt="@@wma.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="wma-hero__badge" i18n="@@wma.hero.badge">🍷 direkt vom Winzer</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="wma-section">
  <div class="content content--wide">
    <h2 class="wma-h2 reveal" i18n="@@wma.adv.h2">Warum die marktbox als Weinautomat?</h2>
    <div class="wma-grid">
      <div class="wma-card reveal">
        <span class="wma-card__ico">🕒</span>
        <h3 i18n="@@wma.adv.c1.h">24/7 verkaufen</h3>
        <p i18n="@@wma.adv.c1.p">Wein für den spontanen Anlass – auch abends, sonntags und feiertags, ganz ohne Personal.</p>
      </div>
      <div class="wma-card reveal">
        <span class="wma-card__ico">🔞</span>
        <h3 i18n="@@wma.adv.c2.h">Mit Altersverifikation</h3>
        <p i18n="@@wma.adv.c2.p">Alkoholverkauf rechtssicher: Der Automat gibt Wein erst nach erfolgreicher Alterskontrolle frei.</p>
      </div>
      <div class="wma-card reveal">
        <span class="wma-card__ico">💳</span>
        <h3 i18n="@@wma.adv.c3.h">Bargeldlos &amp; app-gesteuert</h3>
        <p i18n="@@wma.adv.c3.p">Kartenzahlung am Automaten, Fernwartung und Füllstände per App – ohne täglichen Aufwand.</p>
      </div>
      <div class="wma-card reveal">
        <span class="wma-card__ico">🍇</span>
        <h3 i18n="@@wma.adv.c4.h">Direkt vom Weingut</h3>
        <p i18n="@@wma.adv.c4.p">Verkaufe ohne Zwischenhandel – mit voller Kontrolle über Preis, Sortiment und Präsentation.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link ===== -->
<section class="wma-section wma-live">
  <div class="content content--wide wma-live__grid">
    <div class="wma-live__text reveal">
      <span class="wma-eyebrow" i18n="@@wma.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="wma-h2" i18n="@@wma.live.h2">So sieht der Live-Link aus</h2>
      <p class="wma-lead" i18n="@@wma.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, welche
        Weine gerade verfügbar sind – noch bevor sie losfährt. Das schafft Vertrauen, spart Wege
        und bringt mehr Verkäufe.
      </p>
      <ul class="wma-live__list">
        <li i18n="@@wma.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@wma.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@wma.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="wma-cta">
        <a class="btn btn-primary wma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@wma.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link: Echtzeit-Verfügbarkeit einer Box" i18n-title="@@wma.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@wma.live.cap">Live-Beispiel: Weingut Becker</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="wma-section wma-section--muted">
  <div class="content content--wide">
    <h2 class="wma-h2 reveal" i18n="@@wma.price.h2">Weinautomat kaufen oder mieten</h2>
    <div class="wma-price-grid">
      <div class="wma-price reveal">
        <span class="wma-price__label" i18n="@@wma.price.buyLabel">Kaufen</span>
        <span class="wma-price__value" i18n="@@wma.price.buyValue">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@wma.price.buyP">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div class="wma-price reveal">
        <span class="wma-price__label" i18n="@@wma.price.rentLabel">Mieten</span>
        <span class="wma-price__value" i18n="@@wma.price.rentValue">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@wma.price.rentP">Niedrige Einstiegshürde, planbare monatliche Kosten – ideal zum Starten und Testen.</p>
      </div>
    </div>
    <div class="wma-cta wma-cta--center reveal">
      <a class="btn btn-primary wma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@wma.price.cta">Zum Shop – Weinautomat konfigurieren</a>
    </div>
    <p class="wma-fineprint reveal" i18n="@@wma.price.fineprint">
      Noch unsicher?
      <a [routerLink]="['/', links.blog, blogSlug]">Im Ratgeber: Direktvermarktung dank Weinautomat</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="wma-section">
  <div class="content content--wide">
    <h2 class="wma-h2 reveal" i18n="@@wma.models.h2">Passende Modelle</h2>
    <div class="wma-models">
      <a class="wma-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="wma-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Weinautomat mit 39 Fächern" i18n-alt="@@wma.models.m39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="wma-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@wma.models.m39.p">39 Fächer – für ein breites Weinsortiment und höhere Stückzahlen.</p>
          <span class="wma-model__more" i18n="@@wma.models.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="wma-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="wma-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Weinautomat mit 24 Fächern" i18n-alt="@@wma.models.m24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="wma-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@wma.models.m24.p">24 Fächer – kompakter Einstieg für das Weingut.</p>
          <span class="wma-model__more" i18n="@@wma.models.more2">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="wma-section wma-section--muted">
  <div class="content content--wide">
    <h2 class="wma-h2 reveal" i18n="@@wma.faq.h2">Häufige Fragen zum Weinautomat</h2>
    <div class="wma-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="wma-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="wma-fineprint reveal" i18n="@@wma.faq.fineprint">
      Mehr zum rechtssicheren Alkoholverkauf:
      <a [routerLink]="['/', links.blog, blogAlkohol]">Alkoholisches in Automaten verkaufen</a>.
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="wma-section wma-final reveal">
  <div class="content content--wide">
    <h2 class="wma-h2" i18n="@@wma.final.h2">Bereit für deinen Weinautomaten?</h2>
    <p class="wma-lead" i18n="@@wma.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="wma-cta wma-cta--center">
      <a class="btn btn-primary wma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@wma.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
